import { defineComponent as A, ref as S, openBlock as y, createElementBlock as I, createElementVNode as x, normalizeClass as R, Fragment as Xe, normalizeStyle as G, withDirectives as Z, vShow as _, createCommentVNode as V, createVNode as ve, createTextVNode as ke, toDisplayString as q, inject as oe, watch as we, unref as me, reactive as pe, provide as se, onBeforeMount as lt, onMounted as nt, createBlock as T, renderList as at } from "vue";
const st = { class: "color-input-menu" }, ot = /* @__PURE__ */ A({
  __name: "ColorInputMenu",
  props: {
    inputType: { default: "RGB", type: String }
  },
  emits: ["onChangeInputName"],
  setup(n, { emit: d }) {
    const a = S(n.inputType), i = d, u = (g) => {
      a.value = g, i("onChangeInputName", g);
    };
    return (g, s) => (y(), I("ul", st, [
      x("li", {
        class: R(a.value == "RGB" ? "active" : ""),
        onClick: s[0] || (s[0] = (b) => u("RGB"))
      }, "RGB", 2),
      x("li", {
        class: R(a.value == "HSL" ? "active" : ""),
        onClick: s[1] || (s[1] = (b) => u("HSL"))
      }, "HSL", 2),
      x("li", {
        class: R(a.value == "HSV" ? "active" : ""),
        onClick: s[2] || (s[2] = (b) => u("HSV"))
      }, "HSV", 2),
      x("li", {
        class: R(a.value == "CMYK" ? "active" : ""),
        onClick: s[3] || (s[3] = (b) => u("CMYK"))
      }, "CMYK", 2)
    ]));
  }
}), rt = {
  key: 0,
  class: "ck-cp-controller-bar"
}, it = {
  key: 1,
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  width: "32",
  height: "32",
  viewBox: "0 0 32 32"
}, ut = /* @__PURE__ */ x("path", { d: "M21.5 0h9c0.831 0 1.5 0.669 1.5 1.5v9c0 0.606-0.363 1.156-0.925 1.387s-1.206 0.106-1.637-0.325l-2.438-2.438-5.438 5.438c-0.587 0.588-1.538 0.588-2.119 0l-2-2c-0.587-0.588-0.587-1.537 0-2.119l5.438-5.438-2.444-2.444c-0.431-0.431-0.556-1.075-0.325-1.637s0.781-0.925 1.387-0.925zM10.5 32h-9c-0.831 0-1.5-0.669-1.5-1.5v-9c0-0.606 0.362-1.156 0.925-1.387s1.206-0.106 1.637 0.325l2.438 2.438 5.438-5.438c0.588-0.587 1.537-0.587 2.119 0l2 2c0.588 0.587 0.588 1.538 0 2.119l-5.438 5.438 2.438 2.438c0.431 0.431 0.556 1.075 0.325 1.637s-0.781 0.925-1.387 0.925z" }, null, -1), ct = [
  ut
], dt = {
  key: 1,
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  width: "32",
  height: "32",
  viewBox: "0 0 32 32"
}, pt = /* @__PURE__ */ x("path", { d: "M29 16c0-7.18-5.82-13-13-13s-13 5.82-13 13v0c0 7.18 5.82 13 13 13s13-5.82 13-13v0zM0 16c0-8.837 7.163-16 16-16s16 7.163 16 16v0c0 8.837-7.163 16-16 16s-16-7.163-16-16v0z" }, null, -1), gt = [
  pt
], vt = {
  key: 1,
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  width: "32",
  height: "32",
  viewBox: "0 0 32 32"
}, mt = /* @__PURE__ */ x("path", { d: "M0.013 29.306c0.156 1.512 1.431 2.694 2.987 2.694h26c1.656 0 3-1.344 3-3v-6c0-1.656-1.344-3-3-3h-3v5c0 0.55-0.45 1-1 1s-1-0.45-1-1v-5h-4v5c0 0.55-0.45 1-1 1s-1-0.45-1-1v-5h-4v5c0 0.55-0.45 1-1 1s-1-0.45-1-1v-5h-5c-0.55 0-1-0.45-1-1s0.45-1 1-1h5v-4h-5c-0.55 0-1-0.45-1-1s0.45-1 1-1h5v-4h-5c-0.55 0-1-0.45-1-1s0.45-1 1-1h5v-3c0-1.656-1.344-3-3-3h-6c-1.656 0-3 1.344-3 3v26c0 0.106 0.006 0.206 0.013 0.306z" }, null, -1), ft = [
  mt
], ht = {
  key: 1,
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  width: "32",
  height: "32",
  viewBox: "0 0 32 32"
}, yt = /* @__PURE__ */ x("path", { d: "M0.013 29.306c0.156 1.512 1.431 2.694 2.987 2.694h26c1.656 0 3-1.344 3-3v-6c0-1.656-1.344-3-3-3h-3v5c0 0.55-0.45 1-1 1s-1-0.45-1-1v-5h-4v5c0 0.55-0.45 1-1 1s-1-0.45-1-1v-5h-4v5c0 0.55-0.45 1-1 1s-1-0.45-1-1v-5h-5c-0.55 0-1-0.45-1-1s0.45-1 1-1h5v-4h-5c-0.55 0-1-0.45-1-1s0.45-1 1-1h5v-4h-5c-0.55 0-1-0.45-1-1s0.45-1 1-1h5v-3c0-1.656-1.344-3-3-3h-6c-1.656 0-3 1.344-3 3v26c0 0.106 0.006 0.206 0.013 0.306z" }, null, -1), bt = [
  yt
], kt = {
  key: 1,
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  width: "32",
  height: "32",
  viewBox: "0 0 32 32"
}, $t = /* @__PURE__ */ x("path", { d: "M21.35 1.825l-6.344 6.35-0.588-0.588c-0.781-0.781-2.050-0.781-2.831 0s-0.781 2.050 0 2.831l10 10c0.781 0.781 2.050 0.781 2.831 0s0.781-2.050 0-2.831l-0.587-0.587 6.344-6.35c2.438-2.438 2.438-6.388 0-8.819s-6.387-2.438-8.819 0zM3.462 20.206c-0.938 0.938-1.462 2.212-1.462 3.538v2.65l-1.663 2.494c-0.531 0.794-0.425 1.85 0.25 2.525s1.731 0.781 2.525 0.25l2.494-1.663h2.65c1.325 0 2.6-0.525 3.537-1.462l7.544-7.544-2.831-2.831-7.544 7.544c-0.188 0.188-0.444 0.294-0.706 0.294h-2.256v-2.256c0-0.262 0.106-0.519 0.294-0.706l7.544-7.544-2.831-2.831-7.544 7.544z" }, null, -1), wt = [
  $t
], xt = {
  key: 1,
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  width: "32",
  height: "32",
  viewBox: "0 0 32 32"
}, Ct = /* @__PURE__ */ x("path", { d: "M32 16c0 0.056 0 0.113 0 0.169-0.025 2.281-2.1 3.831-4.381 3.831h-6.119c-1.656 0-3 1.344-3 3 0 0.212 0.025 0.419 0.063 0.619 0.131 0.637 0.406 1.25 0.675 1.869 0.381 0.863 0.756 1.719 0.756 2.625 0 1.988-1.35 3.794-3.337 3.875-0.219 0.006-0.438 0.012-0.662 0.012-8.831 0-15.994-7.162-15.994-16s7.162-16 16-16 16 7.162 16 16zM8 18c0-1.105-0.895-2-2-2s-2 0.895-2 2v0c0 1.105 0.895 2 2 2s2-0.895 2-2v0zM8 12c1.105 0 2-0.895 2-2s-0.895-2-2-2v0c-1.105 0-2 0.895-2 2s0.895 2 2 2v0zM18 6c0-1.105-0.895-2-2-2s-2 0.895-2 2v0c0 1.105 0.895 2 2 2s2-0.895 2-2v0zM24 12c1.105 0 2-0.895 2-2s-0.895-2-2-2v0c-1.105 0-2 0.895-2 2s0.895 2 2 2v0z" }, null, -1), It = [
  Ct
], Mt = {
  key: 1,
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  width: "28",
  height: "32",
  viewBox: "0 0 28 32"
}, Vt = /* @__PURE__ */ x("path", { d: "M4 2c-2.206 0-4 1.794-4 4v20c0 2.206 1.794 4 4 4h20c2.206 0 4-1.794 4-4v-15.169c0-1.063-0.419-2.081-1.169-2.831l-4.831-4.831c-0.75-0.75-1.769-1.169-2.831-1.169h-15.169zM4 8c0-1.106 0.894-2 2-2h12c1.106 0 2 0.894 2 2v4c0 1.106-0.894 2-2 2h-12c-1.106 0-2-0.894-2-2v-4zM14 18c2.209 0 4 1.791 4 4s-1.791 4-4 4v0c-2.209 0-4-1.791-4-4s1.791-4 4-4v0z" }, null, -1), Nt = [
  Vt
], St = {
  key: 1,
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  width: "28",
  height: "32",
  viewBox: "0 0 28 32"
}, Bt = /* @__PURE__ */ x("path", { d: "M8.45 1.106l-0.45 0.894h-6c-1.106 0-2 0.894-2 2s0.894 2 2 2h24c1.106 0 2-0.894 2-2s-0.894-2-2-2h-6l-0.45-0.894c-0.337-0.681-1.031-1.106-1.788-1.106h-7.525c-0.756 0-1.45 0.425-1.787 1.106zM26 8h-24l1.325 21.188c0.1 1.581 1.413 2.813 2.994 2.813h15.362c1.581 0 2.894-1.231 2.994-2.813l1.325-21.188z" }, null, -1), Lt = [
  Bt
], Dt = {
  key: 0,
  class: "ck-cp-linear-angle-container"
}, Rt = { class: "ck-gradient-set-label" }, Tt = ["value"], Ht = {
  key: 1,
  class: "ck-cp-linear-angle-container"
}, Et = { class: "ck-gradient-set-label" }, Yt = ["value"], Xt = { style: { "margin-top": "1rem" } }, Ot = { class: "ck-gradient-set-label" }, Ut = ["value"], Gt = /* @__PURE__ */ A({
  __name: "PickerMenu",
  props: {
    mode: {
      default: "gradient",
      type: String
    },
    inputType: { default: "RGB", type: String },
    gradientType: { default: "linear", type: String },
    isEyeDropperUsing: { default: !1, type: Boolean },
    showColorList: { default: !0, type: Boolean },
    showEyeDrop: { default: !0, type: Boolean },
    showInputMenu: { default: !0, type: Boolean },
    angle: { default: 90, type: Number },
    percentageX: { default: 50, type: Number },
    percentageY: { default: 50, type: Number },
    local: { default: { angle: "", positionX: "", positionY: "" }, type: Object },
    iconClasses: { default: { linear: "", radial: "", ruler: "", eyeDroper: "", inputMenu: "", save: "", delete: "" }, type: Object }
  },
  emits: ["onSaveColor", "onChangeMode", "onChangeInputType", "onDeleteColor", "onClickEyeDropper", "update:angle", "update:percentageX", "update:percentageY", "onInput"],
  setup(n, { emit: d }) {
    const o = S(), a = S(!1), i = S(!1), u = S(!1), g = d, s = (v, m) => {
      switch (m) {
        case "angle":
          g("update:angle", parseInt(v.target.value)), g("onInput");
          break;
        case "percentageX":
          g("update:percentageX", parseInt(v.target.value)), g("onInput");
          break;
        case "percentageY":
          g("update:percentageY", parseInt(v.target.value)), g("onInput");
          break;
      }
    }, b = (v) => {
      u.value = !1, g("onChangeInputType", v);
    }, f = () => {
      u.value = !u.value;
    };
    return (v, m) => (y(), I(Xe, null, [
      x("div", {
        class: "ck-cp-menu",
        style: G(n.mode == "gradient" ? "" : "justify-content: end;")
      }, [
        n.mode == "gradient" ? (y(), I("div", rt, [
          x("button", {
            type: "button",
            class: R(["cp-btn", n.gradientType == "linear" ? "active" : ""]),
            onClick: m[0] || (m[0] = (N) => v.$emit("onChangeMode", "linear")),
            style: G(`${n.iconClasses.linear ? "" : "padding: 7px;"}`)
          }, [
            n.iconClasses.linear ? (y(), I("i", {
              key: 0,
              class: R(n.iconClasses.linear)
            }, null, 2)) : (y(), I("svg", it, ct))
          ], 6),
          x("button", {
            type: "button",
            class: R(["cp-btn", n.gradientType == "radial" ? "active" : ""]),
            onClick: m[1] || (m[1] = (N) => v.$emit("onChangeMode", "radial")),
            style: G(`${n.iconClasses.radial ? "" : "padding: 6px;"}`)
          }, [
            n.iconClasses.radial ? (y(), I("i", {
              key: 0,
              class: R(n.iconClasses.radial)
            }, null, 2)) : (y(), I("svg", dt, gt))
          ], 6),
          Z(x("button", {
            type: "button",
            class: R(["cp-btn", a.value ? "active" : ""]),
            onClick: m[2] || (m[2] = (N) => a.value = !a.value),
            style: G(`${n.iconClasses.ruler ? "" : "padding: 7px;"}`)
          }, [
            n.iconClasses.ruler ? (y(), I("i", {
              key: 0,
              class: R(n.iconClasses.ruler)
            }, null, 2)) : (y(), I("svg", vt, ft))
          ], 6), [
            [_, n.gradientType == "linear"]
          ]),
          Z(x("button", {
            type: "button",
            class: R(["cp-btn", i.value ? "active" : ""]),
            onClick: m[3] || (m[3] = (N) => i.value = !i.value),
            style: G(`${n.iconClasses.ruler ? "" : "padding: 7px;"}`)
          }, [
            n.iconClasses.ruler ? (y(), I("i", {
              key: 0,
              class: R(n.iconClasses.ruler)
            }, null, 2)) : (y(), I("svg", ht, bt))
          ], 6), [
            [_, n.gradientType == "radial"]
          ])
        ])) : V("", !0),
        x("div", {
          ref_key: "rightContainer",
          ref: o,
          class: "ck-cp-controller-bar",
          style: { display: "inline-flex", "justify-content": "end", position: "relative" }
        }, [
          n.isEyeDropperUsing && n.showEyeDrop ? (y(), I("button", {
            key: 0,
            type: "button",
            id: "cp-btn-eyedropper",
            class: "cp-btn",
            style: G(`${n.iconClasses.eyeDroper ? "" : "padding: 7px;"}`),
            onClick: m[4] || (m[4] = (N) => v.$emit("onClickEyeDropper"))
          }, [
            n.iconClasses.eyeDroper ? (y(), I("i", {
              key: 0,
              class: R(n.iconClasses.eyeDroper)
            }, null, 2)) : (y(), I("svg", kt, wt))
          ], 4)) : V("", !0),
          n.showInputMenu ? (y(), I("button", {
            key: 1,
            type: "button",
            class: R(["cp-btn", u.value ? "active" : ""]),
            onClick: f,
            style: G(`${n.iconClasses.inputMenu ? "" : "padding: 7px;"}`)
          }, [
            n.iconClasses.inputMenu ? (y(), I("i", {
              key: 0,
              class: R(n.iconClasses.inputMenu)
            }, null, 2)) : (y(), I("svg", xt, It))
          ], 6)) : V("", !0),
          Z(ve(ot, {
            inputType: n.inputType,
            onOnChangeInputName: b
          }, null, 8, ["inputType"]), [
            [_, u.value]
          ]),
          n.showColorList ? (y(), I("button", {
            key: 2,
            type: "button",
            class: "cp-btn",
            onClick: m[5] || (m[5] = (N) => v.$emit("onSaveColor")),
            style: G(`${n.iconClasses.save ? "" : "padding: 7px;"}`)
          }, [
            n.iconClasses.save ? (y(), I("i", {
              key: 0,
              class: R(n.iconClasses.save)
            }, null, 2)) : (y(), I("svg", Mt, Nt))
          ], 4)) : V("", !0),
          n.mode == "gradient" ? (y(), I("button", {
            key: 3,
            type: "button",
            class: "cp-btn",
            onClick: m[6] || (m[6] = (N) => v.$emit("onDeleteColor")),
            style: G(`${n.iconClasses.delete ? "" : "padding: 7.5px;"}`)
          }, [
            n.iconClasses.delete ? (y(), I("i", {
              key: 0,
              class: R(n.iconClasses.delete)
            }, null, 2)) : (y(), I("svg", St, Lt))
          ], 4)) : V("", !0)
        ], 512)
      ], 4),
      n.mode == "gradient" ? Z((y(), I("div", Dt, [
        x("div", null, [
          x("p", Rt, [
            ke(q(n.local.angle ? n.local.angle : "Angle") + " ", 1),
            x("span", null, q(n.angle) + "°", 1)
          ]),
          x("input", {
            type: "range",
            min: "0",
            max: "360",
            value: n.angle,
            onInput: m[7] || (m[7] = (N) => s(N, "angle"))
          }, null, 40, Tt)
        ])
      ], 512)), [
        [_, n.gradientType == "linear" && a.value]
      ]) : V("", !0),
      n.mode == "gradient" ? Z((y(), I("div", Ht, [
        x("div", null, [
          x("p", Et, [
            ke(q(n.local.positionX ? n.local.positionX : "Position X") + " ", 1),
            x("span", null, q(n.percentageX) + "%", 1)
          ]),
          x("input", {
            type: "range",
            min: "0",
            max: "100",
            value: n.percentageX,
            onInput: m[8] || (m[8] = (N) => s(N, "percentageX"))
          }, null, 40, Yt)
        ]),
        x("div", Xt, [
          x("p", Ot, [
            ke(q(n.local.positionY ? n.local.positionY : "Position Y") + " ", 1),
            x("span", null, q(n.percentageY) + "%", 1)
          ]),
          x("input", {
            type: "range",
            min: "0",
            max: "100",
            value: n.percentageY,
            onInput: m[9] || (m[9] = (N) => s(N, "percentageY"))
          }, null, 40, Ut)
        ])
      ], 512)), [
        [_, n.gradientType == "radial" && i.value]
      ]) : V("", !0)
    ], 64));
  }
}), Pt = /* @__PURE__ */ A({
  __name: "GradientBar",
  emits: ["onAddColor", "onMouseDown"],
  setup(n, { emit: d }) {
    const o = oe("gradientBar"), a = (i) => {
      i.preventDefault();
    };
    return (i, u) => (y(), I("div", {
      class: "gradient-bar",
      onMousedown: u[1] || (u[1] = (g) => i.$emit("onMouseDown", g)),
      onDragstart: a
    }, [
      x("div", {
        ref_key: "gradientBar",
        ref: o,
        class: "gradient-container",
        onDblclick: u[0] || (u[0] = (g) => i.$emit("onAddColor", g))
      }, null, 544)
    ], 32));
  }
}), zt = /* @__PURE__ */ x("div", { class: "colour-area-mask" }, null, -1), At = /* @__PURE__ */ A({
  __name: "PickerWrap",
  emits: ["onMouseDown"],
  setup(n) {
    const d = oe("canvas"), o = oe("pickerWrap"), a = oe("pickerPointer"), i = (u) => {
      u.preventDefault();
    };
    return (u, g) => (y(), I("div", {
      ref_key: "pickerWrap",
      ref: o,
      class: "cp-picker-wrap",
      onMousedown: g[0] || (g[0] = (s) => u.$emit("onMouseDown", s)),
      onDragstart: i
    }, [
      x("canvas", {
        ref_key: "canvas",
        ref: d,
        class: "colour-area"
      }, null, 512),
      zt,
      x("div", {
        ref_key: "pickerPointer",
        ref: a,
        class: "colour-area-point-circle"
      }, null, 512)
    ], 544));
  }
}), Kt = { class: "picker-hue" }, Wt = ["value"], Ft = /* @__PURE__ */ A({
  __name: "PickerHue",
  props: {
    modelValue: { default: 0, type: Number }
  },
  emits: ["update:modelValue", "onInput", "onChange"],
  setup(n, { emit: d }) {
    const o = d, a = (i) => {
      o("update:modelValue", parseFloat(i.target.value)), o("onInput", i);
    };
    return (i, u) => (y(), I("div", Kt, [
      x("input", {
        value: n.modelValue,
        class: "picker-hue-range-slider",
        type: "range",
        min: "0",
        max: "360",
        step: "0.1",
        onInput: a,
        onChange: u[0] || (u[0] = (g) => i.$emit("onChange", g))
      }, null, 40, Wt)
    ]));
  }
}), qt = { class: "opacity-bar" }, jt = { class: "picker-opacity-slider opacity-bar-background" }, Jt = ["value"], Qt = /* @__PURE__ */ A({
  __name: "OpacityBar",
  props: {
    modelValue: { default: 0, type: Number }
  },
  emits: ["update:modelValue", "onInput"],
  setup(n, { emit: d }) {
    const o = oe("opacitySlider"), a = d, i = (u) => {
      a("update:modelValue", parseInt(u.target.value)), a("onInput", u);
    };
    return (u, g) => (y(), I("div", qt, [
      x("div", jt, [
        x("input", {
          ref_key: "opacitySlider",
          ref: o,
          value: n.modelValue,
          class: "opacity__slider",
          type: "range",
          min: "0",
          max: "100",
          onInput: i
        }, null, 40, Jt)
      ])
    ]));
  }
}), Zt = { class: "ck-cp-input-content" }, _t = { class: "ck-cp-input-label" }, el = ["min", "max", "value"], Y = /* @__PURE__ */ A({
  __name: "InputNumber",
  props: {
    label: { default: "", type: String },
    modelValue: { default: 0, type: Number },
    min: { default: 0, type: Number },
    max: { default: 100, type: Number }
  },
  emits: ["update:modelValue"],
  setup(n, { emit: d }) {
    const o = n, a = d, i = S(o.modelValue);
    we(() => o.modelValue, (f, v) => {
      f !== v && (i.value = f);
    }, { immediate: !0 });
    const u = (f) => {
      const v = (N) => {
        i.value = N, a("update:modelValue", N);
      }, m = f.target.value;
      if (!m)
        return v(o.modelValue);
      if (parseInt(m) > o.max)
        return v(o.max);
      a("update:modelValue", parseInt(m));
    }, g = (f) => {
      i.value = f.target.value;
    }, s = (f) => {
      if (["KeyE", "Equal", "Equal", "Backslash", "Slash", "NumpadDecimal", "NumpadAdd"].includes(f.code))
        return f.preventDefault();
      f.code === "Enter" && u(f);
    }, b = u;
    return (f, v) => (y(), I("div", Zt, [
      x("span", _t, q(n.label), 1),
      x("input", {
        type: "number",
        min: n.min,
        max: n.max,
        value: i.value,
        onInput: g,
        onKeydown: s,
        onFocusout: v[0] || (v[0] = //@ts-ignore
        (...m) => me(b) && me(b)(...m))
      }, null, 40, el)
    ]));
  }
}), tl = { class: "ck-cp-input-content color-hex" }, ll = /* @__PURE__ */ x("span", { class: "ck-cp-input-label" }, "HEX", -1), nl = ["value"], al = /* @__PURE__ */ A({
  __name: "InputHex",
  props: {
    modelValue: {}
  },
  emits: ["update:modelValue"],
  setup(n, { emit: d }) {
    const o = n, a = d, i = S(""), u = (f) => {
      const v = f.target.value;
      i.value = v, i.value = `#${v.replace(/#/g, "")}`;
    }, g = (f) => {
      const v = f.target.value;
      if (v === o.modelValue)
        return;
      if (!/^#[0-9a-fA-F]+$/.test(v)) {
        i.value = o.modelValue;
        return;
      }
      let m = v.replace(/#/g, "");
      switch (m.length) {
        case 0:
          m = o.modelValue.replace("#", "");
          break;
        case 1:
        case 2:
          m = m.repeat(3);
          break;
        case 4:
        case 5:
          m = m.slice(0, 3);
          break;
        case 3:
        case 6:
          break;
        default:
          m = m.slice(0, 6);
      }
      i.value = `#${m.toUpperCase()}`, a("update:modelValue", i.value);
    }, s = (f) => {
      f.code === "Enter" && g(f);
    }, b = g;
    return we(() => o.modelValue, (f, v) => {
      f !== v && (i.value = f);
    }, { immediate: !0 }), (f, v) => (y(), I("div", tl, [
      ll,
      x("input", {
        type: "text",
        value: i.value,
        onInput: u,
        onKeydown: s,
        onFocusout: v[0] || (v[0] = //@ts-ignore
        (...m) => me(b) && me(b)(...m))
      }, null, 40, nl)
    ]));
  }
}), sl = (n) => {
  const d = /^rgb\((\s*\d+\s*),(\s*\d+\s*),(\s*\d+\s*)\)$/i;
  if (!d.test(n))
    return null;
  const o = d.exec(n);
  if (!o)
    return null;
  const a = parseInt(o[1].trim(), 10), i = parseInt(o[2].trim(), 10), u = parseInt(o[3].trim(), 10);
  return {
    r: a,
    g: i,
    b: u
  };
}, ol = (n) => {
  const d = /^rgba?\((\s*\d+\s*),(\s*\d+\s*),(\s*\d+\s*),(\s*[\d.]+\s*)\)$/i;
  if (!d.test(n))
    return null;
  const o = d.exec(n);
  if (!o)
    return null;
  const a = parseInt(o[1].trim(), 10), i = parseInt(o[2].trim(), 10), u = parseInt(o[3].trim(), 10), g = parseFloat(o[4].trim());
  return {
    r: a,
    g: i,
    b: u,
    a: g
  };
}, rl = (n) => {
  const d = /^#?([a-f\d]{8})$/i;
  if (!d.test(n))
    return null;
  const o = d.exec(n);
  if (!o)
    return null;
  const a = o[1], i = a.substring(6, 8), u = parseInt(a.substring(0, 2), 16), g = parseInt(a.substring(2, 4), 16), s = parseInt(a.substring(4, 6), 16), b = parseInt(i, 16) / 255;
  return { r: u, g, b: s, a: b };
}, il = (n, d, o, a) => {
  function i(f) {
    const v = f.toString(16);
    return v.length === 1 ? "0" + v : v;
  }
  const u = i(Math.round(n)), g = i(Math.round(d)), s = i(Math.round(o)), b = i(Math.round(a * 255));
  return `#${u}${g}${s}${b}`;
}, ge = (n) => {
  var d;
  try {
    let o = (d = n.replace(
      /^#?([a-f\d])([a-f\d])([a-f\d])$/i,
      // @ts-ignore
      (g, s, b, f) => "#" + s + s + b + b + f + f
    ).substring(1).match(/.{2}/g)) == null ? void 0 : d.map((g) => parseInt(g, 16)), a = o == null ? void 0 : o[0], i = o == null ? void 0 : o[1], u = o == null ? void 0 : o[2];
    return Number.isNaN(a) || Number.isNaN(i) || Number.isNaN(u) || a === void 0 || i === void 0 || u === void 0 ? null : {
      r: a,
      g: i,
      b: u
    };
  } catch {
    return null;
  }
}, Q = (n, d, o) => {
  n = n / 255, d = d / 255, o = o / 255;
  const a = Math.max(n, d, o), i = Math.min(n, d, o);
  let u;
  return a === n ? u = (d - o) / (a - i) : a === d ? u = 2 + (o - n) / (a - i) : u = 4 + (n - d) / (a - i), u *= 60, u < 0 && (u += 360), Number.isNaN(u) && (u = 0), u;
}, ul = (n, d, o) => {
  d = d / 100, o = o / 100;
  let a, i, u, g = [];
  return a = (1 - Math.abs(2 * o - 1)) * d, i = a * (1 - Math.abs(n / 60 % 2 - 1)), u = o - a / 2, n >= 0 && n < 60 && (g = [a, i, 0]), n >= 60 && n < 120 && (g = [i, a, 0]), n >= 120 && n < 180 && (g = [0, a, i]), n >= 180 && n < 240 && (g = [0, i, a]), n >= 240 && n < 300 && (g = [i, 0, a]), n >= 300 && n <= 360 && (g = [a, 0, i]), g.map((s) => Math.round(255 * (s + u)));
}, $e = (n, d, o) => "#" + (16777216 + (o | d << 8 | n << 16)).toString(16).slice(1), He = (n, d, o) => {
  let a = ul(n, d, o);
  return { rgb: a, hexA: $e(a[0], a[1], a[2]) };
}, Ee = (n, d, o) => {
  let a, i, u, g, s, b, f = 0, v = [];
  for (v[0] = n / 255, v[1] = d / 255, v[2] = o / 255, a = v[0], i = v[0], b = 0, u = 0; u < v.length - 1; u++)
    v[u + 1] <= a && (a = v[u + 1]), v[u + 1] >= i && (i = v[u + 1], b = u + 1);
  return b === 0 && (f = (v[1] - v[2]) / (i - a)), b === 1 && (f = 2 + (v[2] - v[0]) / (i - a)), b === 2 && (f = 4 + (v[0] - v[1]) / (i - a)), isNaN(f) && (f = 0), f = f * 60, f < 0 && (f = f + 360), g = (a + i) / 2, a === i ? s = 0 : g < 0.5 ? s = (i - a) / (i + a) : s = (i - a) / (2 - i - a), s = s, { h: f, s, l: g };
}, Ye = (n, d, o) => {
  n = n % 360 / 360, d = Math.min(1, Math.max(0, d)), o = Math.min(1, Math.max(0, o));
  let a, i, u;
  if (d === 0)
    a = i = u = o;
  else {
    const g = (f, v, m) => (m < 0 && (m += 1), m > 1 && (m -= 1), m < 0.16666666666666666 ? f + (v - f) * 6 * m : m < 0.5 ? v : m < 0.6666666666666666 ? f + (v - f) * (0.6666666666666666 - m) * 6 : f), s = o < 0.5 ? o * (1 + d) : o + d - o * d, b = 2 * o - s;
    a = g(b, s, n + 1 / 3), i = g(b, s, n), u = g(b, s, n - 1 / 3);
  }
  return a = Math.round(a * 255), i = Math.round(i * 255), u = Math.round(u * 255), { r: a, g: i, b: u };
}, cl = (n, d, o) => {
  let a = 0, i = 0, u = 0;
  const g = n / 60, s = o * d, b = s * (1 - Math.abs(g % 2 - 1)), f = o - s;
  switch (Math.floor(g) % 6) {
    case 0:
      a = s, i = b, u = 0;
      break;
    case 1:
      a = b, i = s, u = 0;
      break;
    case 2:
      a = 0, i = s, u = b;
      break;
    case 3:
      a = 0, i = b, u = s;
      break;
    case 4:
      a = b, i = 0, u = s;
      break;
    case 5:
      a = s, i = 0, u = b;
      break;
  }
  return {
    r: Math.round((a + f) * 255),
    g: Math.round((i + f) * 255),
    b: Math.round((u + f) * 255)
  };
}, dl = (n, d, o) => {
  n /= 255, d /= 255, o /= 255;
  const a = Math.max(n, d, o), i = Math.min(n, d, o);
  let u, g, s = a;
  const b = a - i;
  if (a !== 0)
    g = b / a;
  else
    return { h: 0, s: 0, v: 0 };
  return b === 0 ? u = 0 : a === n ? u = 60 * ((d - o) / b % 6) : a === d ? u = 60 * ((o - n) / b + 2) : u = 60 * ((n - d) / b + 4), u < 0 && (u += 360), {
    h: Math.round(u),
    s: Math.round(g * 100) / 100,
    v: Math.round(s * 100) / 100
  };
}, pl = (n, d, o) => {
  const a = (2 - d) * o / 2, i = a && a < 1 ? d * o / (a < 0.5 ? a * 2 : 2 - a * 2) : d;
  return { h: n, s: i, l: a };
}, gl = (n, d, o, a) => {
  const i = Math.round(255 * (1 - n) * (1 - a)), u = Math.round(255 * (1 - d) * (1 - a)), g = Math.round(255 * (1 - o) * (1 - a));
  return {
    r: Math.min(255, Math.max(0, i)),
    g: Math.min(255, Math.max(0, u)),
    b: Math.min(255, Math.max(0, g))
  };
}, vl = (n, d, o) => {
  n = n / 255, d = d / 255, o = o / 255;
  const a = 1 - Math.max(n, d, o), i = (1 - n - a) / (1 - a), u = (1 - d - a) / (1 - a), g = (1 - o - a) / (1 - a);
  return {
    c: isNaN(i) ? 0 : i,
    m: isNaN(u) ? 0 : u,
    y: isNaN(g) ? 0 : g,
    k: isNaN(a) ? 0 : a
  };
}, ml = ["cp-theme"], fl = { id: "ck-cp-target-background" }, hl = {
  key: 2,
  class: "ck-cp-input-container"
}, yl = {
  key: 3,
  class: "ck-cp-local-color-conatiner"
}, bl = ["onClick"], $l = /* @__PURE__ */ A({
  __name: "Vue3ColorPicker",
  props: {
    modelValue: { default: "" },
    mode: {
      default: "gradient",
      type: String
    },
    type: { default: "HEX8", type: String },
    inputType: { default: "RGB", type: String },
    theme: { default: "light", type: String },
    colorListCount: { default: 18, type: Number },
    showColorList: { default: !0, type: Boolean },
    showEyeDrop: { default: !0, type: Boolean },
    showAlpha: { default: !0, type: Boolean },
    showInputMenu: { default: !0, type: Boolean },
    showInputSet: { default: !0, type: Boolean },
    disabled: { default: !1, type: Boolean },
    local: {
      default: { angle: "", positionX: "", positionY: "" },
      type: Object
    },
    iconClasses: {
      default: {
        linear: "",
        radial: "",
        ruler: "",
        eyeDroper: "",
        inputMenu: "",
        save: "",
        delete: ""
      },
      type: Object
    }
  },
  emits: ["update:modelValue"],
  setup(n, { emit: d }) {
    const o = n, a = S(null), i = d, u = S(o.modelValue), g = (l) => {
      u.value = l, i("update:modelValue", l);
    }, s = S([
      { id: 1, r: 68, g: 71, b: 119, a: 100, percent: 0, hue: 0, select: !0 },
      { id: 2, r: 0, g: 0, b: 255, a: 100, percent: 100, hue: 0, select: !1 }
    ]), b = S([]), f = S(!1), v = S("linear"), m = pe({
      angle: 90,
      percentageX: 50,
      percentageY: 50
    }), N = S(""), L = S(o.inputType), re = S(!1), xe = S(), ie = S(), F = S(), P = S(), M = S(), H = pe({
      h: 0,
      s: 0,
      l: 0
    }), D = pe({
      h: 0,
      s: 0,
      v: 0
    }), B = pe({
      c: 0,
      m: 0,
      y: 0,
      k: 0
    });
    se("gradientBar", ie), se("canvas", F), se("pickerWrap", P), se("pickerPointer", M), se("opacitySlider", xe);
    let ee = 0, te = 0, Ce = 0, Ie = 0, le = 0, ne = 0;
    const Oe = (l) => {
      !P.value || !M.value || (le = P.value.offsetHeight - M.value.offsetHeight, ne = P.value.offsetWidth - M.value.offsetWidth, Ce = l.clientX - l.target.getBoundingClientRect().left, Ie = l.clientY - l.target.getBoundingClientRect().top, ee = Ce - M.value.offsetWidth / 2, te = Ie - M.value.offsetHeight / 2, M.value.style.left = `${ee}px`, M.value.style.top = `${te}px`, fe(!1), J(), window.addEventListener("mousemove", Me), window.addEventListener("mouseup", Ve));
    }, Me = (l) => {
      l.preventDefault();
      const e = P.value.getBoundingClientRect(), t = l.clientX - e.left - M.value.offsetWidth / 2, r = l.clientY - e.top - M.value.offsetHeight / 2;
      t >= 0 && t <= ne ? (ee = t, M.value.style.left = `${t}px`) : 0 > t ? (ee = 0, M.value.style.left = "0px") : t > ne && (ee = ne, M.value.style.left = `${ne}px`), r >= 0 && r <= le ? (te = r, M.value.style.top = `${r}px`) : 0 > r ? (te = 0, M.value.style.top = "0px") : r > le && (te = le, M.value.style.top = `${le}px`), fe(!1), J();
    }, Ve = () => {
      window.removeEventListener("mousemove", Me), window.removeEventListener("mouseup", Ve);
    }, fe = (l) => {
      if (!l) {
        let e = Ue();
        const t = Ye(K.value, e.s, e.l);
        if (t) {
          if (re.value) {
            let r = s.value.find((c) => c.select == !0);
            r && (r.r = t.r, r.g = t.g, r.b = t.b);
          }
          U(), E();
        }
      }
    }, K = S(0), he = async (l) => {
      const { rgb: e } = He(K.value, 100, 50);
      Re(e), setTimeout(() => {
        fe(l), J();
      }, 0);
    }, Ue = () => {
      let l = { s: 0, l: 0 }, e = P.value.offsetWidth - M.value.offsetWidth, t = P.value.offsetHeight - M.value.offsetHeight, r = parseInt(M.value.style.left), p = 1 - parseInt(M.value.style.top) / t, k = r / e;
      return l.l = p / 2 * (2 - k), l.s = p * k / (1 - Math.abs(2 * l.l - 1)), Number.isNaN(l.s) && (l.s = l.l), l.l = l.l > 1 ? 1 : l.l, l.s = l.s > 1 ? 1 : l.s, l;
    }, ae = () => {
      const l = s.value.find((e) => e.select == !0);
      if (l) {
        const { l: e, s: t } = Ee(l.r, l.g, l.b);
        let r = e, c = t;
        Number.isNaN(c) && (c = r);
        let p = { x: 0, y: 0 }, k = P.value.offsetWidth - M.value.offsetWidth, C = P.value.offsetHeight - M.value.offsetHeight;
        const [$, h] = 2 * r - 1 < 0 ? [
          k * 2 * c / (1 + c),
          C * (1 - r * (1 + c))
        ] : [
          -k * 2 * (r - 1) * c / (r + c - r * c),
          C * (r - 1) * (c - 1)
        ];
        return p.x = $, p.y = h, p;
      } else
        return null;
    }, Ge = () => {
      const l = s.value.find((e) => e.select == !0);
      l && (l.hue = K.value);
    }, j = S(100), Pe = (l) => {
      if (o.showAlpha) {
        const e = l.target, t = s.value.find((r) => r.select == !0);
        t && (t.a = parseInt(e.value), E());
      }
    }, ze = (l) => {
      var t, r, c, p;
      const e = (r = (t = a.value) == null ? void 0 : t.querySelector(".gradient-handle-content")) == null ? void 0 : r.getBoundingClientRect();
      return l === 0 ? "0px" : l === 100 && e ? `${(((c = ie.value) == null ? void 0 : c.offsetWidth) || 0) - (e.width || 0)}px` : `${(((p = ie.value) == null ? void 0 : p.offsetWidth) || 0) * (l / 100) - ((e == null ? void 0 : e.width) || 0) / 2}px`;
    };
    let X = null, O = null;
    const Ne = (l) => {
      var r, c;
      const t = l.target.offsetParent;
      if ((r = t == null ? void 0 : t.id) != null && r.includes("clr-gb-")) {
        const p = t.id.replace("clr-gb-", "");
        O = t;
        const k = s.value.find((C) => C.select == !0);
        if (k && k.id != p) {
          const C = (c = a.value) == null ? void 0 : c.querySelector(
            ".gradient-handle.select"
          );
          C == null || C.classList.remove("select"), t.classList.add("select");
          const $ = s.value.findIndex(
            (h) => h.select == !0
          );
          for (let h = 0; h < s.value.length; h++) {
            const w = s.value[h];
            if (w.id == p) {
              $ != -1 && (s.value[$].select = !1), s.value[h].select = !0, j.value = w.a, W(w.r, w.g, w.b, w.hue, !0), U(), J();
              break;
            }
          }
        }
        window.addEventListener("mousemove", Se), window.addEventListener("mouseup", Ae);
      }
    }, Ae = () => {
      window.removeEventListener("mousemove", Se), window.removeEventListener("mouseup", Ne);
    }, Se = (l) => {
      var p, k;
      l.preventDefault();
      const e = (k = (p = a.value) == null ? void 0 : p.querySelector(".gradient-handle-content")) == null ? void 0 : k.getBoundingClientRect(), t = X == null ? void 0 : X.getBoundingClientRect(), r = (t == null ? void 0 : t.width) - (e == null ? void 0 : e.width);
      let c = l.clientX - ((t == null ? void 0 : t.left) || 0) - ((e == null ? void 0 : e.width) || 0) / 2;
      if (c < 0 ? c = 0 : c > r && (c = r), O) {
        O.style.left = `${c}px`;
        const C = parseFloat(
          (c / ((t == null ? void 0 : t.width) - (e == null ? void 0 : e.width)) * 100).toFixed(0)
        ), $ = s.value.find(
          (h) => h.id == (O == null ? void 0 : O.id.replace("clr-gb-", ""))
        );
        $ && ($.percent = C), E();
      }
    }, Ke = (l) => {
      var C, $;
      const e = X == null ? void 0 : X.getBoundingClientRect(), t = Math.round(
        (l.clientX - ((e == null ? void 0 : e.left) || 0)) / ((e == null ? void 0 : e.width) || 1) * 100
      ), r = s.value.findIndex((h) => h.select == !0), c = s.value[r], p = {
        id: Date.now(),
        r: c.r,
        g: c.g,
        b: c.b,
        a: c.a,
        percent: t,
        hue: c.hue,
        select: !0
      };
      s.value[r].select = !1;
      const k = (C = a.value) == null ? void 0 : C.querySelector(
        ".gradient-handle.select"
      );
      k == null || k.classList.remove("select"), s.value = [...s.value, p], De(p), O = ($ = a.value) == null ? void 0 : $.querySelector(`#clr-gb-${p.id}`), E();
    }, Be = (l) => {
      if (l.r == 0 && l.g == 0 && l.b == 0)
        return !0;
      if (l.r == 255 && l.g == 255 && l.b == 255)
        return !0;
      {
        const e = F.value.getContext("2d", { willReadFrequently: !0 }), t = F.value.width, r = F.value.height, c = e.getImageData(0, 0, t, r).data, p = l.r, k = l.g, C = l.b;
        for (let $ = 0; $ < r; $++)
          for (let h = 0; h < t; h++) {
            const w = ($ * t + h) * 4, z = c[w], et = c[w + 1], tt = c[w + 2];
            if (z === p && et === k && tt === C)
              return !0;
          }
        return !1;
      }
    }, W = (l, e, t, r, c) => {
      setTimeout(() => {
        if (Be({ r: l, g: e, b: t })) {
          let p = ae();
          p && (M.value.style.left = `${p.x}px`, M.value.style.top = `${p.y}px`);
        } else {
          let p = ae();
          p && (M.value.style.left = `${p.x}px`, M.value.style.top = `${p.y}px`), K.value = r, he(c);
        }
      }, 0);
    }, Le = () => {
      s.value.forEach((t) => De(t)), We();
      const l = s.value[0];
      K.value = l.hue, he(!0);
      let e = ae();
      e && (M.value.style.left = `${e.x}px`, M.value.style.top = `${e.y}px`), U(), E();
    }, De = (l) => {
      if (o.mode == "gradient") {
        let e = document.createElement("div");
        e.id = `clr-gb-${l.id}`, e.classList.add("gradient-handle"), e.style.left = ze(l.percent);
        let t = document.createElement("div");
        t.classList.add("gradient-handle-content"), l.select == !0 && e.classList.add("select"), e.appendChild(t), X && X.appendChild(e);
      }
    }, Re = (l) => {
      const e = F.value.getContext("2d", { willReadFrequently: !0 }), t = F.value.width, r = F.value.height;
      e.fillStyle = `rgb(${l[0]},${l[1]},${l[2]})`, e.fillRect(0, 0, t, r);
      let c = e.createLinearGradient(0, 0, t - 12, 0);
      c.addColorStop(0, "rgb(255,255,255)"), c.addColorStop(1, "rgba(255,255,255,0)"), e.fillStyle = c, e.fillRect(0, 0, t, r);
      let p = e.createLinearGradient(0, 0, 0, r);
      p.addColorStop(0, "rgba(0,0,0,0)"), p.addColorStop(1, "rgb(0,0,0)"), e.fillStyle = p, e.fillRect(0, 0, t, r);
    }, U = () => {
      if (o.showAlpha) {
        let l = s.value.find((e) => e.select == !0);
        l && (xe.value.style.background = ` linear-gradient(90deg,rgba(255, 255, 255, 0) 0%, rgba(${l.r}, ${l.g}, ${l.b}, 100) 97%)`);
      }
    }, E = () => {
      var l;
      if (o.mode == "gradient") {
        s.value.sort((c, p) => c.percent - p.percent);
        let e = "linear-gradient(90deg, ", t;
        if (v.value == "linear") {
          t = `linear-gradient(${m.angle}deg, `;
          for (let c = 0; c < s.value.length; c++) {
            const { r: p, g: k, b: C, a: $, percent: h } = s.value[c];
            s.value.length - 1 == c ? (e = e + `rgba(${p},${k},${C},${$ / 100}) ${h}%)`, t = t + `rgba(${p},${k},${C},${$ / 100}) ${h}%)`) : (e = e + `rgba(${p},${k},${C},${$ / 100}) ${h}%, `, t = t + `rgba(${p},${k},${C},${$ / 100}) ${h}%, `);
          }
        } else {
          t = `radial-gradient(circle at ${m.percentageX}% ${m.percentageY}%, `;
          for (let c = 0; c < s.value.length; c++) {
            const { r: p, g: k, b: C, a: $, percent: h } = s.value[c];
            s.value.length - 1 == c ? (e = e + `rgba(${p},${k},${C},${$ / 100}) ${h}%)`, t = t + `rgba(${p},${k},${C},${$ / 100}) ${h}%)`) : (e = e + `rgba(${p},${k},${C},${$ / 100}) ${h}%, `, t = t + `rgba(${p},${k},${C},${$ / 100}) ${h}%, `);
          }
        }
        ie.value.style.backgroundImage = e;
        let r = (l = a.value) == null ? void 0 : l.querySelector("#ck-cp-target-background");
        r && (r.style.backgroundImage = t, re.value && g(r.style.backgroundImage));
      } else {
        const { r: e, g: t, b: r, a: c } = s.value[0];
        let p = "";
        switch (o.type) {
          case "HEX8":
            p = il(e, t, r, c / 100);
            break;
          case "RGBA":
            p = `rgba(${e},${t},${r},${c / 100})`;
            break;
          case "RGB":
            p = `rgb(${e},${t},${r})`;
            break;
          case "HEX":
            p = $e(e, t, r);
            break;
        }
        g(p);
      }
    }, We = () => {
      s.value.forEach((l) => {
        l.hue = Q(l.r, l.g, l.b);
      });
    }, Fe = (l) => {
      v.value = l, E();
    }, qe = () => {
      var l, e;
      if (s.value.length > 2) {
        const t = s.value.findIndex((r) => r.select == !0);
        if (t !== -1) {
          const r = s.value[t].id;
          s.value.splice(t, 1);
          const c = (l = a.value) == null ? void 0 : l.querySelector(`#clr-gb-${r}`);
          c == null || c.remove();
          const p = s.value[0];
          p && (p.select = !0, O = (e = a.value) == null ? void 0 : e.querySelector(`#clr-gb-${p.id}`), O == null || O.classList.add("select"), W(p.r, p.g, p.b, p.hue, !1), J(), E());
        }
      }
    }, je = () => {
      var t;
      const l = (t = a.value) == null ? void 0 : t.querySelector("#cp-btn-eyedropper");
      l == null || l.classList.add("active"), new EyeDropper().open().then((r) => {
        const { sRGBHex: c } = r, p = s.value.find((C) => C.select == !0), k = ge(c);
        if (k) {
          const C = Q(k.r, k.g, k.b);
          if (p && (p.hue = C, p.r = k.r, p.g = k.g, p.b = k.b), Be(k)) {
            const $ = ae();
            $ && (M.value.style.left = `${$.x}px`, M.value.style.top = `${$.y}px`);
          } else {
            K.value = C;
            const { rgb: $ } = He(C, 100, 50);
            Re($);
            const h = ae();
            h && (M.value.style.left = `${h.x}px`, M.value.style.top = `${h.y}px`);
          }
          J(), U(), E(), l == null || l.classList.remove("active");
        }
      }).catch(() => {
        l == null || l.classList.remove("active");
      });
    }, ue = (l, e) => {
      if (e != "a") {
        const t = s.value.find((r) => r.select == !0);
        if (t) {
          const r = Q(t.r, t.g, t.b);
          t.hue = r, W(
            t.r,
            t.g,
            t.b,
            t.hue,
            !0
          ), E(), U();
        }
      } else
        j.value = l, E(), U();
    }, ye = () => {
      const l = s.value.find((e) => e.select == !0);
      if (l && !Number.isNaN(H.h) && !Number.isNaN(H.s) && !Number.isNaN(H.l)) {
        const { r: e, g: t, b: r } = Ye(H.h, H.s / 100, H.l / 100);
        l.hue = H.h, l.r = e, l.g = t, l.b = r, W(
          l.r,
          l.g,
          l.b,
          l.hue,
          !0
        ), E(), U();
      }
    }, be = () => {
      const l = s.value.find((e) => e.select == !0);
      if (l && !Number.isNaN(D.h) && !Number.isNaN(D.s) && !Number.isNaN(D.v)) {
        const { r: e, g: t, b: r } = cl(D.h, D.s / 100, D.v / 100), { h: c } = pl(D.h, D.s / 100, D.v / 100);
        l.hue = c, l.r = e, l.g = t, l.b = r, W(
          l.r,
          l.g,
          l.b,
          l.hue,
          !0
        ), E(), U();
      }
    }, ce = () => {
      const l = s.value.find((e) => e.select == !0);
      if (l && !Number.isNaN(B.c) && !Number.isNaN(B.m) && !Number.isNaN(B.y) && !Number.isNaN(B.k)) {
        const { r: e, g: t, b: r } = gl(
          B.c / 100,
          B.m / 100,
          B.y / 100,
          B.k / 100
        ), c = Q(e, t, r);
        l.hue = c, l.r = e, l.g = t, l.b = r, W(
          l.r,
          l.g,
          l.b,
          l.hue,
          !0
        ), E(), U();
      }
    }, Je = () => {
      if (N.value) {
        const l = ge(N.value);
        if (l) {
          const e = Q(l.r, l.g, l.b), t = s.value.find((r) => r.select == !0);
          t && (t.r = l.r, t.g = l.g, t.b = l.b, t.hue = e, W(l.r, l.g, l.b, t.hue, !0), E(), U(), de(L.value));
        }
      }
    }, J = () => {
      const l = s.value.find((e) => e.select == !0);
      l && (N.value = $e(l.r, l.g, l.b).toUpperCase()), de(L.value);
    }, Qe = (l) => {
      N.value = l;
      let e = ge(N.value);
      if (e) {
        const t = Q(e.r, e.g, e.b), r = s.value.find((c) => c.select == !0);
        r && (r.r = e.r, r.g = e.g, r.b = e.b, r.hue = t, W(e.r, e.g, e.b, r.hue, !0), E(), U());
      }
    };
    window.EyeDropper && (f.value = !0);
    const Ze = () => {
      if (!b.value.find((e) => e === N.value)) {
        b.value.length === o.colorListCount && b.value.pop();
        let e = N.value;
        b.value.unshift(e), localStorage.setItem(
          "ck-cp-local-color-list",
          JSON.stringify(b.value)
        );
      }
    }, _e = (l = "") => {
      if (o.mode == "gradient") {
        let e = l.includes("linear") ? "linear" : "radial", t = [];
        if (v.value = e, e == "linear") {
          let r = /^linear-gradient\((.*)\)$/, c = l.replace(";", "").trim().match(r), p = /,\s*(?![^()]*\))/;
          if (c) {
            let k = c[1].split(p);
            for (let C = 0; C < k.length; C++) {
              const $ = k[C];
              let h = {
                id: C,
                r: 0,
                g: 0,
                b: 0,
                a: 100,
                percent: 100,
                hue: 0,
                select: !1
              };
              if ($.includes("deg"))
                m.angle = parseInt($.replace("deg", ""));
              else if ($.includes("rgba")) {
                let w = $.trim().replace(/rgba|\(|\)|%/g, "").replace(/,/g, " ").split(" ");
                w = w.filter((z) => z.trim() !== ""), h.r = parseInt(w[0]), h.g = parseInt(w[1]), h.b = parseInt(w[2]), h.a = parseFloat(w[3]) * 100, h.percent = parseInt(w[4]), t.push(h);
              } else if ($.includes("rgb")) {
                let w = $.trim().replace(/rgb|\(|\)|%/g, "").replace(/,/g, " ").split(" ");
                w = w.filter((z) => z.trim() !== ""), h.r = parseInt(w[0]), h.g = parseInt(w[1]), h.b = parseInt(w[2]), h.percent = parseInt(w[3]), t.push(h);
              }
            }
          }
        } else {
          let r = /^radial-gradient\((.*)\)$/, c = l.replace(";", "").trim().match(r), p = /,\s*(?![^()]*\))/;
          if (c) {
            let k = c[1].split(p);
            for (let C = 0; C < k.length; C++) {
              const $ = k[C];
              let h = {
                id: C,
                r: 0,
                g: 0,
                b: 0,
                a: 100,
                percent: 100,
                hue: 0,
                select: !1
              };
              if ($.includes("circle at")) {
                let w = $.replace("circle at ", "").replace(" ", "").replace(/%/g, " ").trim().split(" ");
                m.percentageX = parseInt(w[0]), m.percentageY = parseInt(w[1]);
              } else if ($.includes("rgba")) {
                let w = $.replace(/rgba|\(|\)|%/g, "").replace(/,/g, " ").split(" ");
                w = w.filter((z) => z.trim() !== ""), h.r = parseInt(w[0]), h.g = parseInt(w[1]), h.b = parseInt(w[2]), h.a = parseFloat(w[3]) * 100, h.percent = parseInt(w[4]), t.push(h);
              } else if ($.includes("rgb")) {
                let w = $.replace(/rgb|\(|\)|%/g, "").replace(/,/g, " ").split(" ");
                w = w.filter((z) => z.trim() !== ""), h.r = parseInt(w[0]), h.g = parseInt(w[1]), h.b = parseInt(w[2]), h.percent = parseInt(w[3]), t.push(h);
              }
            }
          }
        }
        t.length > 1 && (s.value = t, s.value[0].select = !0, j.value = s.value[0].a);
      } else if (l) {
        let e = {
          r: 0,
          g: 0,
          b: 0,
          a: 0
        };
        if (l.includes("#"))
          if (l.length >= 8)
            e = rl(l);
          else {
            let t = ge(l);
            t ? (e.a = 1, e.r = t.r, e.g = t.g, e.b = t.b) : e = null;
          }
        else if (l.includes("rgb"))
          if (l.includes("rgba"))
            e = ol(l);
          else {
            let t = sl(l);
            t ? (e.a = 1, e.r = t.r, e.g = t.g, e.b = t.b) : e = null;
          }
        e && (s.value[0].r = e.r, s.value[0].b = e.b, s.value[0].g = e.g, s.value[0].a = parseInt((e.a * 100).toFixed(0)), j.value = s.value[0].a, s.value[0].hue = 0);
      }
    }, de = (l) => {
      const e = s.value.find((t) => t.select == !0);
      if (e) {
        switch (l) {
          case "RGB":
            break;
          case "HSL": {
            const { h: t, s: r, l: c } = Ee(
              e.r,
              e.g,
              e.b
            );
            H.h = Math.round(t), H.s = Math.round(r * 100), H.l = Math.round(c * 100);
            break;
          }
          case "HSV": {
            const { h: t, s: r, v: c } = dl(
              e.r,
              e.g,
              e.b
            );
            D.h = Math.round(t), D.s = Math.round(r * 100), D.v = Math.round(c * 100);
            break;
          }
          case "CMYK":
            {
              const { c: t, m: r, y: c, k: p } = vl(
                e.r,
                e.g,
                e.b
              );
              B.c = Math.round(t * 100), B.m = Math.round(r * 100), B.y = Math.round(c * 100), B.k = Math.round(p * 100);
            }
            break;
        }
        L.value = l;
      }
    }, Te = (l) => {
      l && _e(l), Le();
    };
    return we(() => o.modelValue, (l, e) => {
      l !== e && l !== u.value && (s.value.forEach((t) => {
        const r = X == null ? void 0 : X.querySelector(`#clr-gb-${t.id}`);
        r == null || r.remove();
      }), Te(l));
    }), lt(() => {
      let l = localStorage.getItem("ck-cp-local-color-list");
      l && (b.value = JSON.parse(l));
    }), nt(() => {
      var l;
      o.mode == "gradient" && (X = (l = a.value) == null ? void 0 : l.querySelector(".gradient-bar")), Te(o.modelValue), de(L.value), re.value = !0;
    }), (l, e) => (y(), I("div", {
      class: R(["ck-cp-container", n.disabled ? "ck-cp-disabled " : ""]),
      ref_key: "pickerTemplateRef",
      ref: a,
      "cp-theme": n.theme
    }, [
      ve(At, { onOnMouseDown: Oe }),
      ve(Gt, {
        angle: m.angle,
        "onUpdate:angle": e[0] || (e[0] = (t) => m.angle = t),
        percentageX: m.percentageX,
        "onUpdate:percentageX": e[1] || (e[1] = (t) => m.percentageX = t),
        local: n.local,
        iconClasses: n.iconClasses,
        inputType: L.value,
        percentageY: m.percentageY,
        "onUpdate:percentageY": e[2] || (e[2] = (t) => m.percentageY = t),
        mode: n.mode,
        showColorList: n.showColorList,
        showInputMenu: n.showInputMenu,
        showEyeDrop: n.showEyeDrop,
        isEyeDropperUsing: f.value,
        gradientType: v.value,
        onOnChangeMode: Fe,
        onOnInput: E,
        onOnClickEyeDropper: je,
        onOnDeleteColor: qe,
        onOnSaveColor: Ze,
        onOnChangeInputType: de
      }, null, 8, ["angle", "percentageX", "local", "iconClasses", "inputType", "percentageY", "mode", "showColorList", "showInputMenu", "showEyeDrop", "isEyeDropperUsing", "gradientType"]),
      n.mode == "gradient" ? (y(), T(Pt, {
        key: 0,
        onOnAddColor: Ke,
        onOnMouseDown: Ne
      })) : V("", !0),
      ve(Ft, {
        modelValue: K.value,
        "onUpdate:modelValue": e[3] || (e[3] = (t) => K.value = t),
        onOnInput: e[4] || (e[4] = (t) => he(!1)),
        onOnChange: Ge
      }, null, 8, ["modelValue"]),
      n.showAlpha ? (y(), T(Qt, {
        key: 1,
        modelValue: j.value,
        "onUpdate:modelValue": e[5] || (e[5] = (t) => j.value = t),
        onOnInput: Pe
      }, null, 8, ["modelValue"])) : V("", !0),
      Z(x("div", fl, null, 512), [
        [_, !1]
      ]),
      re.value && n.showInputSet ? (y(), I("div", hl, [
        L.value !== "CMYK" ? (y(), T(al, {
          key: 0,
          modelValue: N.value,
          "onUpdate:modelValue": [
            e[6] || (e[6] = (t) => N.value = t),
            Je
          ]
        }, null, 8, ["modelValue"])) : V("", !0),
        L.value == "RGB" ? (y(), T(Y, {
          key: 1,
          label: "R",
          min: 0,
          max: 255,
          modelValue: s.value.find((t) => t.select == !0).r,
          "onUpdate:modelValue": [
            e[7] || (e[7] = (t) => s.value.find((r) => r.select == !0).r = t),
            e[8] || (e[8] = (t) => ue(t, "r"))
          ]
        }, null, 8, ["modelValue"])) : V("", !0),
        L.value == "RGB" ? (y(), T(Y, {
          key: 2,
          label: "G",
          min: 0,
          max: 255,
          modelValue: s.value.find((t) => t.select == !0).g,
          "onUpdate:modelValue": [
            e[9] || (e[9] = (t) => s.value.find((r) => r.select == !0).g = t),
            e[10] || (e[10] = (t) => ue(t, "g"))
          ]
        }, null, 8, ["modelValue"])) : V("", !0),
        L.value == "RGB" ? (y(), T(Y, {
          key: 3,
          label: "B",
          min: 0,
          max: 255,
          modelValue: s.value.find((t) => t.select == !0).b,
          "onUpdate:modelValue": [
            e[11] || (e[11] = (t) => s.value.find((r) => r.select == !0).b = t),
            e[12] || (e[12] = (t) => ue(t, "b"))
          ]
        }, null, 8, ["modelValue"])) : V("", !0),
        L.value == "HSL" ? (y(), T(Y, {
          key: 4,
          label: "H",
          min: 0,
          max: 360,
          modelValue: H.h,
          "onUpdate:modelValue": [
            e[13] || (e[13] = (t) => H.h = t),
            ye
          ]
        }, null, 8, ["modelValue"])) : V("", !0),
        L.value == "HSL" ? (y(), T(Y, {
          key: 5,
          label: "S",
          min: 0,
          max: 100,
          modelValue: H.s,
          "onUpdate:modelValue": [
            e[14] || (e[14] = (t) => H.s = t),
            ye
          ]
        }, null, 8, ["modelValue"])) : V("", !0),
        L.value == "HSL" ? (y(), T(Y, {
          key: 6,
          label: "L",
          min: 0,
          max: 100,
          modelValue: H.l,
          "onUpdate:modelValue": [
            e[15] || (e[15] = (t) => H.l = t),
            ye
          ]
        }, null, 8, ["modelValue"])) : V("", !0),
        L.value == "HSV" ? (y(), T(Y, {
          key: 7,
          label: "H",
          min: 0,
          max: 360,
          modelValue: D.h,
          "onUpdate:modelValue": [
            e[16] || (e[16] = (t) => D.h = t),
            be
          ]
        }, null, 8, ["modelValue"])) : V("", !0),
        L.value == "HSV" ? (y(), T(Y, {
          key: 8,
          label: "S",
          min: 0,
          max: 100,
          modelValue: D.s,
          "onUpdate:modelValue": [
            e[17] || (e[17] = (t) => D.s = t),
            be
          ]
        }, null, 8, ["modelValue"])) : V("", !0),
        L.value == "HSV" ? (y(), T(Y, {
          key: 9,
          label: "V",
          min: 0,
          max: 100,
          modelValue: D.v,
          "onUpdate:modelValue": [
            e[18] || (e[18] = (t) => D.v = t),
            be
          ]
        }, null, 8, ["modelValue"])) : V("", !0),
        L.value == "CMYK" ? (y(), T(Y, {
          key: 10,
          label: "C",
          min: 0,
          max: 100,
          modelValue: B.c,
          "onUpdate:modelValue": [
            e[19] || (e[19] = (t) => B.c = t),
            ce
          ]
        }, null, 8, ["modelValue"])) : V("", !0),
        L.value == "CMYK" ? (y(), T(Y, {
          key: 11,
          label: "M",
          min: 0,
          max: 100,
          modelValue: B.m,
          "onUpdate:modelValue": [
            e[20] || (e[20] = (t) => B.m = t),
            ce
          ]
        }, null, 8, ["modelValue"])) : V("", !0),
        L.value == "CMYK" ? (y(), T(Y, {
          key: 12,
          label: "Y",
          min: 0,
          max: 100,
          modelValue: B.y,
          "onUpdate:modelValue": [
            e[21] || (e[21] = (t) => B.y = t),
            ce
          ]
        }, null, 8, ["modelValue"])) : V("", !0),
        L.value == "CMYK" ? (y(), T(Y, {
          key: 13,
          label: "K",
          min: 0,
          max: 100,
          modelValue: B.k,
          "onUpdate:modelValue": [
            e[22] || (e[22] = (t) => B.k = t),
            ce
          ]
        }, null, 8, ["modelValue"])) : V("", !0),
        n.showAlpha ? (y(), T(Y, {
          key: 14,
          label: "A",
          min: 0,
          max: 100,
          style: { "margin-right": "2px" },
          modelValue: s.value.find((t) => t.select == !0).a,
          "onUpdate:modelValue": [
            e[23] || (e[23] = (t) => s.value.find((r) => r.select == !0).a = t),
            e[24] || (e[24] = (t) => ue(t, "a"))
          ]
        }, null, 8, ["modelValue"])) : V("", !0)
      ])) : V("", !0),
      b.value.length > 0 && n.showColorList ? (y(), I("div", yl, [
        (y(!0), I(Xe, null, at(b.value, (t) => (y(), I("div", {
          key: `color-${t}`,
          class: "ck-cp-color-item",
          style: G({ backgroundColor: t }),
          onClick: (r) => Qe(t)
        }, null, 12, bl))), 128))
      ])) : V("", !0)
    ], 10, ml));
  }
});
export {
  $l as Vue3ColorPicker
};
